import { Component, inject, OnInit } from '@angular/core';
import { GoogleMapsLoaderService } from './shared/services/google-maps-loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  googleMapService = inject(GoogleMapsLoaderService);

  ngOnInit(): void {
    this.googleMapService.loadScript().catch(err => console.error('Error loading Google Maps', err))
  }

}
